export enum ViewMode {
  ADMIN = "admin",
  VIEWER = "viewer",
  CONFIRMATION_QA = "confirmation-qa",
  CONFIRMATION_QA_FEEDBACK = "confirmation-qa-feedback",
  COVERAGE_QA = "coverage-qa",
  COVERAGE_QA_FEEDBACK = "coverage-qa-feedback",
}

export type {
  CoverageQaTaskData,
  CoverageQaTaskResult,
  CoverageQaResult,
  CoverageQaRejectionReason,
  CoverageQaTaskReason,
} from "./coverage";

/**
 * Router state a task page passes when it bounces back to the jobs table
 * because the job had no task to serve — the table shows a notice so the
 * redirect isn't silent.
 */
export interface NoTaskAvailableState {
  noTaskAvailableJobId: string;
  /**
   * "finished": the labeler worked through the job's last task themselves.
   * "unavailable" (default): they never got a task — taken by someone else or
   * not eligible.
   */
  noTaskReason?: "finished" | "unavailable";
}
